/* Default colors */
const defaultColors = [
    { color: '#ffffff', name: 'white' },
    { color: '#392F43', name: 'black' },
    { color: '#3373dc', name: 'royal blue' },
    { color: '#209cef', name: 'sky blue' },
    { color: '#2BAD59', name: 'green' },
    { color: '#ff3860', name: 'pink' },
    { color: '#7941b6', name: 'purple' },
    { color: '#F7812B', name: 'orange' },
];